import { z } from 'zod';
import { UFS } from '../../../shared/data/brasil';

const cepDigits = z
  .string()
  .trim()
  .transform((s) => s.replace(/\D/g, ''))
  .refine((s) => s.length === 8, 'CEP deve ter 8 dígitos');

export const companyAddressInputSchema = z.object({
  cep: cepDigits,
  logradouro: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  numero: z.string().trim().min(1, 'Obrigatório').max(20, 'Máximo 20 caracteres'),
  complemento: z
    .string()
    .trim()
    .max(100, 'Máximo 100 caracteres')
    .nullish()
    .transform((v) => (v == null || v === '' ? null : v)),
  bairro: z.string().trim().min(1, 'Obrigatório').max(100, 'Máximo 100 caracteres'),
  cidade: z.string().trim().min(1, 'Obrigatório').max(100, 'Máximo 100 caracteres'),
  uf: z
    .string()
    .trim()
    .transform((s) => s.toUpperCase())
    .pipe(z.enum(UFS, { errorMap: () => ({ message: 'UF inválida' }) })),
  ibge: z
    .string()
    .trim()
    .transform((s) => s.replace(/\D/g, ''))
    .refine((s) => s.length === 7, 'IBGE deve ter 7 dígitos'),
  ativo: z.boolean().optional(),
});

export type CompanyAddressFormValues = z.input<typeof companyAddressInputSchema>;
